import { ItemStatus } from '@/types/item';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

const itemStatusName = (status: ItemStatus): string => {
  return status === 'closed' ? 'Done' : snakeToTitleCase(status);
};

export default itemStatusName;
